import { type } from "@testing-library/user-event/dist/type";
import actionTypes from "../actionTypes";

export const getUserVisualReportAction = (data) => ({
  type: actionTypes.reportTypes.graphicalReportTypes.GET_USER_VISUAL_REPORT,
  payload: data,
});

export const getUserDistributionSummaryAction = (data) => ({
  type: actionTypes.reportTypes.graphicalReportTypes
    .GET_USER_DISTRIBUTION_SUMMARY,
  payload: data,
});

export const getClassDistributionSummaryAction = (data) => ({
  type: actionTypes.reportTypes.graphicalReportTypes
    .GET_CLASS_DISTRIBUTION_SUMMARY,
  payload: data,
});

export const getClassVisualReportAction = (data) => ({
  type: actionTypes.reportTypes.graphicalReportTypes.GET_CLASS_VISUAL_REPORT,
  payload: data,
});

export const getTenantUsersAction = (data) => ({
  type: actionTypes.reportTypes.commonTypes.GET_TENANT_USERS,
  payload: data,
});

export const getTrainingTypesAction = (data) => ({
  type: actionTypes.reportTypes.commonTypes.GET_TRAINING_TYPES,
  payload: data,
});

export const getFilterUserDistributionSummaryAction = (data) => ({
  type: actionTypes.reportTypes.graphicalReportTypes
    .FILTER_USER_DISTRIBUTION_SUMMARY,
  payload: data,
});

export const getFilterUserVisualReportAction = (data) => ({
  type: actionTypes.reportTypes.graphicalReportTypes.FILTER_USER_VISUAL_REPORT,
  payload: data,
});

export const getFilterClassDistributionSummaryAction = (data) => ({
  type: actionTypes.reportTypes.graphicalReportTypes
    .FILTER_CLASS_DISTRIBUTION_SUMMARY,
  payload: data,
});

export const getFilterClassVisualReportAction = (data) => ({
  type: actionTypes.reportTypes.graphicalReportTypes.FILTER_CLASS_VISUAL_REPORT,
  payload: data,
});

export const getAssignedClassAction = (data) => ({
  type: actionTypes.reportTypes.graphicalReportTypes.GET_ASSIGNED_CLASS,
  payload: data,
});

export const getUserGroupAction = (data) => ({
  type: actionTypes.reportTypes.commonTypes.GET_USER_GROUP,
  payload: data,
});

export const getClassNameAction = (data) => ({
  type: actionTypes.reportTypes.commonTypes.GET_CLASS_NAME,
  payload: data,
});

export const getUserShotClassReportAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes.GET_USER_SHOTCLASS_REPORT,
  payload: data,
});

export const getShotClassUserReportAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes.GET_SHOTCLASS_USER_REPORT,
  payload: data,
});

export const getCountryListAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes.GET_COUNTRY_LIST,
  payload: data,
});

export const getStateListAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes.GET_STATE_LIST,
  payload: data,
});

export const getCityListAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes.GET_CITY_LIST,
  payload: data,
});

export const getWorkOfficeListAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes.GET_WORK_OFFICE_LIST,
  payload: data,
});

export const getProductCategoryListAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes.GET_PRODUCT_CATEGORY_LIST,
  payload: data,
});

export const getUserClassCompletionAdvanceReportAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes
    .GET_USER_CLASS_COMPLETION_REPORT,
  payload: data,
});

export const getUserClassCompletionGraphReportAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes
    .GET_USER_CLASS_COMPLETION_GRAPH_REPORT,
  payload: data,
});

export const getSurveyReportAction = (data) => ({
  type: actionTypes.reportTypes.surveyReportTypes.GET_SURVEY_REPORT,
  payload: data,
});
export const getClassesWithSurveryAction = (data) => ({
  type: actionTypes.reportTypes.surveyReportTypes.GET_CLASSES_WITH_SURVEY,
  payload: data,
});
export const getClassesWithScoredSurveryAction = (data) => ({
  type: actionTypes.reportTypes.surveyReportTypes
    .GET_CLASSES_WITH_SCORED_SURVEY,
  payload: data,
});

export const getSearchClassNameAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes.GET_SEARCH_CLASS_NAME,
  payload: data,
});
export const sendRemainderAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes.SEND_RAMAINDER,
  payload: data,
});

export const getDefaultShotClassInformationAction = (data) => ({
  type: actionTypes.reportTypes.analyticalReportTypes
    .GET_DEFAULT_SHOTCLASS_INFORMATION,
  payload: data,
});

export const getUserDistributionCSVReportAction = (data) => ({
  type: actionTypes.reportTypes.tabularReportTypes
    .GET_USER_DISTRIBUTION_CSV_REPORT,
  payload: data,
});

export const getQuizReportAction = (data) => ({
  type: actionTypes.reportTypes.quizReportTypes.GET_QUIZ_REPORT,
  payload: data,
});

export const getAccessReportAction = (data) => ({
  type: actionTypes.reportTypes.accessReportTypes.GET_ACCESS_REPORT,
  payload: data,
});

export const getTotalActiveUsersAction = (data) => ({
  type: actionTypes.reportTypes.adoptionReportTypes.GET_TOTAL_ACTIVE_USERS,
  payload: data,
});

export const getMobileInstallationTrendAction = (data) => ({
  type: actionTypes.reportTypes.adoptionReportTypes
    .GET_MOBILE_INSTALLATION_COUNT,
  payload: data,
});

export const getUserGroupAccessDetailsAction = (data) => ({
  type: actionTypes.reportTypes.adoptionReportTypes
    .GET_USERGROUP_ACCESS_DETAILS,
  payload: data,
});

export const getUserGroupClassUsageDetailsAction = (data) => ({
  type: actionTypes.reportTypes.adoptionReportTypes
    .GET_USERGROUP_CLASS_USAGE_DETAILS,
  payload: data,
});

export const getShotclassCompletionTrendAction = (data) => ({
  type: actionTypes.reportTypes.adoptionReportTypes
    .GET_SHOTCLASS_COMPLETION_TREND,
  payload: data,
});

export const getClassWiseUsageDeatilsAction = (data) => ({
  type: actionTypes.reportTypes.adoptionReportTypes
    .GET_CLASS_WISE_USAGE_DETAILS,
  payload: data,
});

export const getNoOfUserAccessedShotclassApplicationAction = (data) => ({
  type: actionTypes.reportTypes.adoptionReportTypes
    .GET_NUMBER_OF_USER_ACCESSED_SHOTCLASS_APPLICATION,
  payload: data,
});

export const getNoOfUserAccessedShotclassesAction = (data) => ({
  type: actionTypes.reportTypes.adoptionReportTypes
    .GET_NUMBER_OF_USER_ACCESSED_SHOTCLASSESS,
  payload: data,
});
export const getMobileAppInstallationCountAction = (data) => ({
  type: actionTypes.reportTypes.adoptionReportTypes
    .GET_MOBILE_APP_INSTALLATION_COUNT,
  payload: data,
});
